import { createIconComponent } from './createIconComponent';
import { glyphs } from './glyphs';

export const Icon = createIconComponent(glyphs);
